import { useState } from "react";
import { cn } from "utils/helpers";
import { Flex } from "@chakra-ui/react";
import FilterButton from "components/FuncButton/FilterButton";
import FilterDrawer from "components/RFQ/CustomFilterDrawer/FilterDrawer";
import SearchBar from "components/RFQ/SearchBar/SearchBar";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
import { SelectedModalButton } from "./SelectedModalButton";

export const SmartFieldQuestionnaireBase = ({
	className,
	question,
	required,
	smartField,
	description,
	searchPlaceholder,
	showFilter = true,
	showSearch = true,
	children,
	isLoading,
	filteringList,
	selectedFilter,
	setSelectedFilter,
	setSearch,
	error,
	touched,
	type,
	selectedData,
	isClientPreview,
	...props
}) => {
	const [openDrawer, setOpenDrawer] = useState(false);

	const { answer = {} } = props;
	const { type: answerType } = answer;
	const companyId = props.companyId;

	const showSelectedModalButton =
		(answerType === "project_experience" || answerType === "key_personnel") &&
		selectedData?.length > 0;

	return (
		<div
			className={cn(`${required && error && touched && ""} ${className} mb-2`)}
			{...props}
		>
			<Flex className="flex-col flex-wrap items-start gap-2 lg:flex-row lg:items-center lg:justify-between">
				<BidderQuestionnaireHeader
					question={question}
					required={required}
					error={error}
					touchedField={props?.touchedField}
					description={description}
				/>
				<Flex className="items-center gap-2">
					{showSelectedModalButton && (
						<SelectedModalButton
							type={answerType}
							questionId={question.id}
							companyId={companyId}
							selectedData={selectedData}
						/>
					)}
					{showSearch && (
						<SearchBar
							setState={setSearch}
							placeholder={searchPlaceholder}
							className="min-w-[360px]"
						/>
					)}
					{showFilter && (
						<FilterButton
							onClick={() => setOpenDrawer(true)}
							filters={selectedFilter}
						/>
					)}
				</Flex>
			</Flex>
			<div>
				{isClientPreview && (
					<div className="h-max min-w-[150px] rounded-md p-2 italic text-gray-500 shadow-md">
						Suppliers will be able to select from any existing items they have
						uploaded to their profile (example shown below).
						<br />
						If a supplier does not have any existing items, they can choose to
						add one or enter free text, you will then have access to this
						information.
					</div>
				)}
				<Flex className="w-full gap-5 overflow-x-auto py-6 pl-1">
					{children}
					{showFilter && (
						<FilterDrawer
							isOpen={openDrawer}
							onClose={() => setOpenDrawer(false)}
							filterOptions={filteringList}
							filters={selectedFilter}
							setFilters={setSelectedFilter}
						/>
					)}
				</Flex>
			</div>
		</div>
	);
};

// Helper function to filter data for preview mode
export const filterSmartFieldOptionForSubmittedRFQ = (
	smartFieldData,
	value,
	isDisabled
) => {
	if (isDisabled) {
		return smartFieldData?.filter((data) => value?.includes(data.id));
	}
	return smartFieldData;
};
